import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Row, Col, Container } from 'react-bootstrap';
import * as api from '~/Services/Service';
import { salvarEmExcel } from '~/Utils/Helpers';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import Loading from '~/Components/Loading';
import FiltrosRelatorio from './FiltrosRelatorio';
import GraficoMotivosBarraLinha from './GraficoMotivosBarraLinha';
import TabelaMotivos from './TabelaMotivos';

const RelatorioMotivosNaoCompra = () => {
  const [dadosGrafico, setDadosGrafico] = useState(null);
  const [dadosRelatorio, setDadosRelatorio] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [opcoesEmpreendimentos, setOpcoesEmpreendimentos] = useState([]);
  const [filtrosAtuais, setFiltrosAtuais] = useState(null);

  useEffect(() => {
    const carregarOpcoes = async () => {
      try {
        const emps = await api.obterEmpreendimentosMotivosNaoCompra();
        setOpcoesEmpreendimentos(emps);
      } catch (err) {
        toast.error('Erro ao carregar empreendimentos.');
      }
    };
    carregarOpcoes();
  }, []);

  const handleSubmit = async values => {
    setIsLoading(true);
    setDadosGrafico(null);
    setDadosRelatorio(null);
    try {
      const filtros = {
        codigo_familia: values.codigo_familia || null,
        data_inicial: values.data_inicial || null,
        data_final: values.data_final || null,
        tipo_cancelamento: values.tipo_cancelamento,
      };
      setFiltrosAtuais(filtros);

      const [grafico, relatorio] = await Promise.all([
        api.consultarRelatorioMotivosNaoCompra(filtros),
        api.consultarRelatorioMotivosNaoCompraDetalhado(filtros),
      ]);

      setDadosGrafico(grafico);
      setDadosRelatorio(relatorio);
    } catch (err) {
      toast.error(err.message || 'Erro ao consultar motivos de nao compra.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleExportExcel = async () => {
    if (!filtrosAtuais) return;
    setIsExporting(true);
    try {
      await salvarEmExcel(
        filtrosAtuais,
        '/relatorios/motivos-nao-compra/exportar-excel'
      );
    } catch (err) {
      toast.error('Erro ao exportar para Excel.');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Container fluid className="px-3 py-3">
      <HeaderAzul title="Motivos Nao Compra" />

      <FiltrosRelatorio
        onSubmit={handleSubmit}
        isLoading={isLoading}
        opcoesEmpreendimentos={opcoesEmpreendimentos}
      />

      {isLoading && <Loading label="Carregando relatorio" />}

      {dadosGrafico && (
        <>
          <Row>
            <Col xs={12}>
              <GraficoMotivosBarraLinha
                titulo="Motivos Nao Compra"
                dados={dadosGrafico.motivos}
              />
            </Col>
          </Row>

          {dadosRelatorio && dadosRelatorio.length > 0 && (
            <Row>
              <Col xs={12}>
                <TabelaMotivos
                  dados={dadosRelatorio}
                  onExportExcel={handleExportExcel}
                  isExporting={isExporting}
                />
              </Col>
            </Row>
          )}
        </>
      )}
    </Container>
  );
};

export default RelatorioMotivosNaoCompra;
